/**
 * LABC2026 Survey — Access Configuration
 *
 * Controls who can access the survey admin pages (Statistics & Config).
 * Add/remove emails here to grant/revoke access.
 * Case-insensitive matching.
 */
export const SURVEY_ADMIN_EMAILS: string[] = [
  'omerson.e.cruz@gmail.com',
  'henryybalez33@gmail.com',
  'camille.cruz@clubwealth.com',
  'tarahellickson@gmail.com',
  'michael@hellickson.com'
];

/**
 * Check if a user has survey admin access.
 * @param user - user_bundle.user object (needs auth_email or email field)
 */
export function hasSurveyAccess(user: any): boolean {
  if (!user) return false;
  // httpHandler2 converts snake_case to camelCase, so auth_email -> authEmail
  const email = (user.authEmail || user.auth_email || user.email || user.crmEmail || user.crm_email || '').toLowerCase().trim();
  return SURVEY_ADMIN_EMAILS.some(e => e.toLowerCase() === email);
}
